import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import WarningIcon from "@mui/icons-material/Warning";
import CircularProgress from "@mui/material/CircularProgress";
import ActionModal from "src/components/modals/action-modal";

function DeleteShipmentModal({ title, descr, onClose, onDelete, shipment }) {
  const [loading, setLoading] = useState(false);
  const [deleteCorrespondingAssets, setDeleteCorrespondingAssets] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await onDelete(deleteCorrespondingAssets);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const handleCheckboxChange = event => {
    setDeleteCorrespondingAssets(event.target.checked);
  };

  return (
    <ActionModal
      maxWidth={480}
      title={
        <>
          <Box mr={1}>{title}</Box>
          <WarningIcon sx={{ color: "#ff9800" }} />
        </>
      }
      onClose={onClose}
    >
      <Box mt={1}>
        <Typography align="center" color="text.secondary">
          {descr}
        </Typography>

        <Box mt={2} display="flex" flexDirection="column" alignItems="center">
          <FormControlLabel
            control={
              <Switch
                checked={deleteCorrespondingAssets}
                onChange={handleCheckboxChange}
                color="primary"
              />
            }
            label={
              <Typography variant="body2" color="text.secondary">
                Also delete corresponding inventory items
              </Typography>
            }
            labelPlacement="start"
            sx={{ m: 0 }}
          />
        </Box>
      </Box>
      <Box mt={2.5}>
        <Grid container spacing={1}>
          <Grid size={6}>
            <Button onClick={onClose} variant="outlined" fullWidth>
              Cancel
            </Button>
          </Grid>
          <Grid size={6}>
            <Button
              onClick={handleDelete}
              color="primary"
              variant="contained"
              fullWidth
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} />}
            >
              Delete
            </Button>
          </Grid>
        </Grid>
      </Box>
    </ActionModal>
  );
}

export default DeleteShipmentModal;
